<template>
  <div class="merge-layout">
    <div v-if="!loading">
      <div class="top">
        <h2>
          <slot name="type">{{ items.type }}</slot>
        </h2>
        <actions aria-role="list" position="is-bottom-left">
          <template>
            <slot name="actions" />
          </template>
        </actions>
      </div>
      <div class="columns">
        <div class="column is-6">
          <slot name="column-left">
            <p class="description">
              {{ items.txt_left }}
            </p>
            <br />
            <parametrs-list
              :items.sync="items.pipelines"
              :parameters="properties.pipeParameters"
              :disabledDrawButtons="imgLoading"
            />
          </slot>
        </div>
        <div class="column is-6 column-center">
          <slot name="column-center">
            <p class="description">
              {{ items.txt_center }}
            </p>
            <br />
            <parametrs-list
              :items.sync="items.parameters"
              :parameters="properties.parameters"
              :disabledDrawButtons="imgLoading"
            />
          </slot>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <div class="save-container">
            <edit-button :editOptions="['save']" @click="save" :disabled="status.endsWith('...')">
              <template>
                <span class="text">Save and run merge</span>
              </template>
            </edit-button>
            <span class="status-text">{{ status }}</span>
          </div>
        </div>
      </div>
    </div>
    <loader v-else />
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Actions from '@/components/Actions'
import EditButton from '@/components/EditButton'
import ParametrsList from '@/components/ParametrsList'

export default {
  name: 'SettingsLayout',
  components: {
    Loader,
    Actions,
    EditButton,
    ParametrsList
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    imgLoading: {
      type: Boolean,
      default: false
    },
    mergeRunning: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    items: {
      type: Object,
      default() {
        return {}
      }
    },
    properties: {
      type: Object,
      default() {
        return {}
      }
    },
    status: {
      type: String,
      default: ''
    }
  },
  methods: {
    save() {
      this.$emit('change', this.items)
      this.$emit('click:save')
    }
  },
  model: {
    event: 'change'
  }
}
</script>

<style lang="scss">
.merge-layout {
  .visual-drawing {
    position: relative;
    width: 100%;
    .visual-sample {
      object-fit: contain;
      max-height: 80vh;
    }
    .canvas-container {
      position: absolute !important;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0;
    }
  }
  .field.is-grouped.is-buttons-under-canvas {
    .control {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .top {
    display: flow-root;
    margin-bottom: 1.25rem;
    h2 {
      font-weight: bold;
      float: left;
      font-size: 150%;
    }
    .actions {
      float: right;
    }
  }
  .columns .column {
    .button.test {
      color: #3273dc;
      border-color: #3273dc;
      padding: 0rem 1.25rem;
      height: 1.25rem;
      margin-right: 1.25rem;
      font-weight: bold;
      float: left;
    }
    .v-spinner.test {
      float: left;
      height: 1.25rem;
      .v-clip {
        width: 1.25rem !important;
        height: 1.25rem !important;
      }
    }
  }
  .save-container {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .status-text {
    display: inline-block;
    line-height: 2.5em;  /* Adjust this value to match button height if needed */
  }
}
</style>
